import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ACMRemoteAssignment } from '../../../shared/interfaces/equipment.interfaces';

const basePath = '/account/acm_remote';

@Injectable({
  providedIn: 'root',
})

export class AccountACMRemoteService {

  constructor(private http: HttpClient) { }

  // Get assignments by account
  getACMRemoteAssignmentsByAccountId(accountId: number): Observable<ACMRemoteAssignment[]> {
    return this.http.get<any[]>(`${basePath}/${accountId}`).pipe(
      map(data => data.map(item => ({
        id: item.id,
        remote_id: item.remote_id,
        remote_description: item.remote_description,
        account_id: item.account_id,
        user_id: item.user_id,
        user_name: item.user_name,
        actions: item.actions
      })))
    );
  }

  // Assign remote to an account and user
  assignACMRemote(assignment: ACMRemoteAssignment): Observable<any> {
    const body = {
      "account_id": assignment.account_id,
      "user_id": assignment.user_id,
      "remote_id": assignment.remote_id,
      "actions": assignment.actions
    }
    return this.http.post<any>(`${basePath}`, body);
  }

  // Remove remote assignment
  unassignACMRemote(id: number): Observable<any> {
    return this.http.delete<any>(`${basePath}/${id}`);
  }

  // Update remote assignment
  updateACMRemoteAssignment(assignment: ACMRemoteAssignment): Observable<any> {
    const body = {
      "account_id": assignment.account_id,
      "user_id": assignment.user_id,
      "remote_id": assignment.remote_id,
      "actions": assignment.actions
    }
    return this.http.put<any>(`${basePath}/${assignment.id}`, body);
  }

  // Get remotes linked to an account
  getACMRemotesByAccountId(accountId: number): Observable<any> {
    return this.http.get<any>(`${basePath}/${accountId}`);
  }

}
